<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row v-if="userData">
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card elevation="6" class="pl-4 pr-4 pb-4 mt-0 mb-0">
          <v-row>
            <v-col cols="6">
              <v-card-subtitle class="pl-0 ml-0">
                <h3 class="black-text">User Details</h3>
              </v-card-subtitle>
              <v-text-field v-model="userData.email" label="Email Address" outlined></v-text-field>
              <v-text-field v-model="userData.forename" :rules="[rules.required]" label="Forename *" outlined>
              </v-text-field>
              <v-text-field v-model="userData.surname" :rules="[rules.required]" label="Surname *" outlined>
              </v-text-field>
              <v-text-field v-model="userData.mobile" label="Mobile Phone" outlined></v-text-field>
              <v-text-field v-model="userData.phone" label="Home Phone" outlined></v-text-field>

              <v-textarea v-model="userData.signature" label="Signature" outlined></v-textarea>
            </v-col>
            <v-col cols="6">
              <v-card-subtitle class="pl-0 ml-0">
                <h3 class="black-text">Contact Details</h3>
              </v-card-subtitle>
              <v-text-field v-model="userData.address1" label="Address 1" outlined></v-text-field>
              <v-text-field v-model="userData.address2" label="Address 2" outlined></v-text-field>
              <v-text-field v-model="userData.address3" label="Address 3" outlined></v-text-field>
              <v-text-field v-model="userData.town" label="Town" outlined></v-text-field>
              <v-text-field v-model="userData.county" label="County / State" outlined></v-text-field>
              <v-text-field v-model="userData.postcode" label="Postcode / ZIP" outlined></v-text-field>
              <v-select :items="countryData" item-text="country" item-value="id" v-model="userData.countryId"
                label="Country" outlined></v-select>
              <v-card-subtitle class="pl-0 mt-0 pt-0">
                <v-btn color="error" @click="resetUserFields()">Reset</v-btn>
                <v-btn color="primary" right absolute @click="updateUserDetails()">Save</v-btn>
                <v-spacer />
              </v-card-subtitle>
              <v-card-subtitle v-if="updateUserDetailsMessage" class="pr-0 pl-0 pb-0 mb-0 mt-0 pt-0">
                <v-alert dismissible close-text="Close Alert" border="left" :type="getUpdateUserDetailsResponseType()">
                  {{ this.updateUserDetailsMessage }}
                </v-alert>
              </v-card-subtitle>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-card class="pl-4 pr-4 pb-4 mt-0 mb-0" elevation="6">
                <v-card-subtitle class="pl-0 ml-0">
                  <h3 class="black-text">Change Avatar</h3>
                </v-card-subtitle>
                <v-row>
                  <v-col>Current Avatar:
                    <v-list-item-avatar outlined rounded size="80" left v-if="userData.avatar">
                      <v-img :src="getAvatarUrl(userData.avatar)"></v-img>
                    </v-list-item-avatar>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-file-input outlined chips show-size accept="image/*" label="Click here to select a new avatar"
                      @change="avatarFileChanged"></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-spacer />
                    <v-btn color="primary" dark class="mb-2" @click="uploadNewAvatar">Upload</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-card-subtitle v-if="updateAvatarMessage" class="pr-0 pl-0 pb-0 mb-0">
                      <v-alert  dismissible close-text="Close Alert" border="left"  :type="getUpdateAvatarResponseType()">
                        {{ this.updateAvatarMessage }}
                      </v-alert>
                    </v-card-subtitle>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col>
              <v-card class="pl-4 pr-4 pb-4 mt-0 mb-0" elevation="6">
                <v-card-subtitle class="pl-0 ml-0">
                  <h3 class="black-text">Change Password</h3>
                </v-card-subtitle>
                <v-text-field v-model="oldPassword" label="Old Password" autocomplete="false" outlined
                  :type="oldPasswordType" :append-icon="oldPasswordType == 'password' ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="
                    oldPasswordType = oldPasswordType == 'password' ? 'text' : 'password'
                  "></v-text-field>
                <v-text-field v-model="newPassword" label="New Password" autocomplete="false" outlined
                  :type="newPasswordType" :append-icon="newPasswordType == 'password' ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="
                    newPasswordType = newPasswordType == 'password' ? 'text' : 'password'
                  "></v-text-field>
                <v-text-field v-model="confirmNewPassword" label="Confirm New Password" autocomplete="false" outlined
                  :rules="checkNewPasswords()" :type="confirmPasswordType" :append-icon="
                    confirmPasswordType == 'password' ? 'mdi-eye-off' : 'mdi-eye'
                  " @click:append="
  confirmPasswordType =
  confirmPasswordType == 'password' ? 'text' : 'password'
"></v-text-field>
                <v-spacer />
                <v-btn color="primary" right @click="updatePassword()">Update Password</v-btn>
                <v-card-subtitle v-if="updatePasswordMessage" class="pr-0 pl-0 pb-0 mb-0">
                  <v-alert  dismissible close-text="Close Alert" border="left"  :type="getUpdatePasswordResponseType()">
                    {{ this.updatePasswordMessage }}
                  </v-alert>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  name: "ManageProfile",
  methods: {
    getAvatarUrl(avatar) {
      return userFunctions.getFullAvatarUrl(avatar);
    },
    avatarFileChanged(file) {
      this.updateAvatarSucceeded = null;
      this.updateAvatarMessage = null;
      this.newAvatar = null;
      this.newAvatarBase64 = null;
      if (file) {
        this.newAvatar = file;
        this.readBase64Image(file);
      }
    },
    async readBase64Image(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.newAvatarBase64 = e.target.result.slice(e.target.result.indexOf(",") + 1);
      };
      await reader.readAsDataURL(file);
    },
    async uploadNewAvatar() {
      this.updateAvatarSucceeded = null;
      this.updateAvatarMessage = null;

      if (!this.newAvatar || !this.newAvatarBase64) {
        this.updateAvatarSucceeded = false;
        this.updateAvatarMessage = "Please Select An Image";
        return; //TODO error handling
      }
      let uploadAvatarRequest = serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        this.newAvatar.name,
        this.newAvatar.type,
        this.newAvatarBase64
      );

      let uploadAvatarResponse = await serverFunctions.getPostResponse(
        "/uploadAvatar",
        uploadAvatarRequest
      );

      this.updateAvatarSucceeded = uploadAvatarResponse[0].success;
      this.updateAvatarMessage = this.updateAvatarSucceeded
        ? "Avatar Updated"
        : uploadAvatarResponse[0].failureReason;

      this.userData.avatar = uploadAvatarResponse[0].imagePathAndFilename;
    },
    checkNewPasswords() {
      if (this.newPassword != this.confirmNewPassword) {
        return ["Passwords Must Match"];
      }
      if (this.newPassword && this.newPassword.length < 8) {
        return ["Password must be at least 8 characters long"];
      }
      if (!this.newPassword) {
        return [];
      }
      return [];
    },
    getUpdatePasswordResponseType() {
      if (this.updatePasswordMessage) {
        return this.updatePasswordSucceeded ? "success" : "error";
      }
    },
    getUpdateUserDetailsResponseType() {
      if (this.updateUserDetailsMessage) {
        return this.updateUserDetailsSucceeded ? "success" : "error";
      }
    },
    getUpdateAvatarResponseType() {
      if (this.updateAvatarMessage) {
        return this.updateAvatarSucceeded ? "success" : "error";
      }
    },
    resetUserFields() {
      this.userData = JSON.parse(JSON.stringify(this.originalUserData));
    },
    async getUserData() {
      const getUserDetails = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser()
      );
      let responseData = await serverFunctions.getPostResponse(
        "/getUser",
        getUserDetails
      );
      this.userData = responseData[0];
      this.originalUserData = JSON.parse(JSON.stringify(this.userData));
    },
    mandatoryFieldsArePresent() {
      if (!this.userData.email || !this.userData.forename || !this.userData.surname) {
        return false;
      }
      return true;
    },
    async updateUserDetails() {

      if (!this.mandatoryFieldsArePresent()) {
        this.updateUserDetailsSucceeded = false;
        let errorMessage = "Email, Forename, Surname and Country are all mandatory fields";
        this.updateUserDetailsMessage = errorMessage
        return;
      }

      const getUpdateUserRequest = serverFunctions.getUpdateUserDataRequestObject(
        userFunctions.getLoggedInUser(),
        this.userData
      );
      let updateUserResponse = await serverFunctions.getPostResponse(
        "/updateUser",
        getUpdateUserRequest
      );

      this.updateUserDetailsSucceeded = updateUserResponse[0].success;
      this.updateUserDetailsMessage = this.updateUserDetailsSucceeded
        ? "Details Updated"
        : updateUserResponse[0].failureReason;
      if (this.updateUserDetailsSucceeded) {
        this.userData = updateUserResponse[0].updatedUser;
        this.originalUserData = JSON.parse(JSON.stringify(this.userData));
        userFunctions.setuser(this.userData);
      }
    },
    async updatePassword() {
      if (this.checkNewPasswords().length > 0) {
        return;
      }

      const updatePasswordRequest = serverFunctions.getUpdatePasswordRequest(
        userFunctions.getLoggedInUser(),
        this.oldPassword,
        this.newPassword
      );

      let updatePasswordResponse = await serverFunctions.getPostResponse(
        "/updatePassword",
        updatePasswordRequest
      );
      this.updatePasswordSucceeded = updatePasswordResponse[0].success;
      this.updatePasswordMessage = this.updatePasswordSucceeded
        ? "Password Changed"
        : updatePasswordResponse[0].failureReason;
    },
    async getCountryData() {
      this.countryData = await serverFunctions.getResponse("/getCountries");
    },
  },
  data: () => ({
    userData: null,
    originalUserData: null,
    updatePasswordSucceeded: null,
    updatePasswordMessage: null,
    updateAvatarSucceeded: null,
    updateAvatarMessage: null,
    updateUserDetailsSucceeded: null,
    updateUserDetailsMessage: null,
    countryData: null,
    oldPassword: null,
    oldPasswordType: "password",
    newPassword: null,
    newPasswordType: "password",
    confirmNewPassword: null,
    confirmPasswordType: "password",
    newAvatar: null,
    newAvatarBase64: null,
    rules: {
      required: (value) => !!value || "Required",
    },

  }),
  beforeMount() {
    this.getUserData();
    this.getCountryData();
    userFunctions.updateLastViewed('profile');
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
